/**
 * Enum for used MIME types.
 * @readonly
 * @enum {string}
 */
export const MIME_TYPES = {
    BINARY: 'binary',
    JSON: 'json',
    MERGE_PATCH_JSON: 'application/merge-patch+json'
}
